// Users.js

import React, { Component } from 'react';
import { Button, Form, Container, Row, Col, ButtonToolbar, Overlay, Popover } from 'react-bootstrap';
import Config from '../Config';
import ScrollArea from 'react-scrollbar';
import Modal from 'react-awesome-modal';

import { JsonToExcel } from 'react-json-excel';

import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import Column from 'react-virtualized/dist/commonjs/Table/Column';
import Table from 'react-virtualized/dist/commonjs/Table';
import SortDirection from 'react-virtualized/dist/commonjs/Table/SortDirection';
import SortIndicator from 'react-virtualized/dist/commonjs/Table/SortIndicator';
import styles from './Table.css';

// class RowItem extends Component {
//     static defaultProps = {
//         item: null,
//         enable: false,
//         onPress: () => { },
//     }
//     constructor(props) {
//         super(props);
//         this.state = {
//             answervisible : false
//         };
//     }

//     handleRowClick = () => {
//         this.props.onPress(this.props.item);
//         event.preventDefault();
//     }
//     render(){
//         return (
//             <tr onClick={this.handleRowClick}>
//             <td>{this.props.item.ID}</td>
//             <td>{this.props.item.EMAIL}</td>
//             <td>{this.props.item.NAME}</td>
//             <td>{this.props.item.REGDATE}</td>
//             </tr>
//         );
//     }
// };

const className = 'class-name-for-style',
    filename = 'User_Excel-file',
    fields = {
        "ID": "번호",
        "EMAIL": "EMAIL",
        "NAME": "이름",
        "REGDATE": "등록일",
    },
    style = {
        padding: "5px",
        background: "#3c8dbc",
        border: "1px #367fa9",
        borderRadius: "3px",
        padding: "6px 12px",
        color: "#ffffff",
        font: "14px",
        height: "37.64px"
    }


export default class Users extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sendcount: 0,
            results: [],
            rowlist: [],
            answervisible: false,
            item: { EMAIL: '', NAME: '', REGDATE: '' }
        };
    }

    handleRowClick = (item) => {
        console.log(item);

        event.preventDefault();
    }

    handleRowDoubleClick = ( item ) => {
        console.log(item);
        if (window.confirm(item.rowData.NAME +" 에게 검수 권한을 지정하시겠습니까?")) {
            console.log("Confirmed!");
            item.rowData.permission = 1;
        } else {
            item.rowData.permission = 0;
        }

        Config.fetchData('users/updateuserpermission', {
            ID: item.rowData.ID,
            permission: item.rowData.permission
        }, (result, count) => {
            console.log('updateuserpermission=', count);
            this.setState({ sendcount: count })
        }, true);

        event.preventDefault();
    }

    componentDidMount() {
        Config.fetchData('usersall', {
        }, (result, count) => {
            console.log('count=', count);
            this.setState({ rowlist: result , results : result })
        }, true);
    }

    handleClose = () => {
        console.log('handleClose');
        this.setState({ answervisible: false });
    }

    handleScroll(scrollData) {
        console.log(scrollData);
    }

    _noRowsRenderer() {
        return <div>No rows</div>;
    }

    _onScrollToRowChange(event) {
        const { rowCount } = this.state;
        let scrollToIndex = Math.min(
            rowCount - 1,
            parseInt(event.target.value, 10),
        );

        if (isNaN(scrollToIndex)) {
            scrollToIndex = undefined;
        }

        this.setState({ scrollToIndex });
    }

    _rowClassName({ index }) {
        if (index < 0) {
            return "headerRow";
        } else {
            return index % 2 === 0 ? "evenRow" : "oddRow";
        }
    }

    onClickSearch = () => {
        if (this.state.searchText.trim().length < 1) {
            this.setState({ rowlist: this.state.results });
        } else {
            this.setState({ rowlist: this.state.results.filter(item => item.EMAIL.includes(this.state.searchText.trim())) });
        }
    }

    handleSearchChange = (event) => {
        event.preventDefault(); // form의 기본 제출 동작을 방지합니다.
        var newValue = this.state.searchText;
        newValue = event.target.value;
        this.setState({ searchText: newValue }, () => {
            this.onClickSearch();
        });
    };
    
    render() {
        let scrollbarStyles = { borderRadius: 5 };
        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box">
                                <div className="box-header with-border">
                                    <table>
                                        <tr>
                                            <td>
                                                <h3 className="box-title">회원관리</h3>
                                            </td>
                                            <td width="16"></td>
                                            <td>
                                                <Form style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <Form.Control type="title" value={this.state.searchText} onChange={this.handleSearchChange} placeholder="EMAIL을 입력하세요." />
                                                    <Button variant="primary" onClick={this.onClickSearch}>검색</Button>
                                                </Form>
                                            </td>
                                            <td width="16"></td>
                                            <td>
                                                {this.state.rowlist.length > 0 ?
                                                    <JsonToExcel
                                                        data={this.state.rowlist}
                                                        className={className}
                                                        filename={filename}
                                                        fields={fields}
                                                        style={style}
                                                    />
                                                    :
                                                    null
                                                }
                                            </td>
                                            <td width="10"></td>
                                            <td> 검수 권한을 지정하려면 대상자를 더블 클릭하세요.</td>
                                        </tr>
                                    </table>
                                </div>
                                <div className="box-body" style={{ margin: 20 }}>
                                    <div className="row" >
                                        <AutoSizer disableHeight>
                                            {({ width }) => (
                                                <Table
                                                    ref="Table"
                                                    headerClassName={'headerColumn'}
                                                    onRowClick={this.handleRowClick}
                                                    onRowDoubleClick={this.handleRowDoubleClick}
                                                    headerHeight={30}
                                                    height={800}
                                                    noRowsRenderer={this._noRowsRenderer}
                                                    overscanRowCount={10}
                                                    rowClassName={this._rowClassName}
                                                    rowHeight={40}
                                                    rowGetter={({ index }) => this.state.rowlist[index]}
                                                    rowCount={this.state.rowlist.length}
                                                    scrollToIndex={this.state.scrollToIndex}
                                                    width={width}>
                                                    <Column
                                                        width={80}
                                                        disableSort
                                                        label="#"
                                                        dataKey="ID"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={500}
                                                        disableSort
                                                        label="EMAIL"
                                                        dataKey="EMAIL"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={500}
                                                        disableSort
                                                        label="이름"
                                                        dataKey="NAME"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={500}
                                                        disableSort
                                                        label="실제이름"
                                                        dataKey="REALNAME"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={200}
                                                        disableSort
                                                        label="등록일"
                                                        dataKey="REGDATE"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={100}
                                                        disableSort
                                                        label="권한"
                                                        dataKey="permission"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                </Table>
                                            )}
                                        </AutoSizer>
                                        {/* <ScrollArea style={{  width: '100%' , height: 700 }}
                                            className="area"
                                            contentClassName="content"
                                            verticalScrollbarStyle={scrollbarStyles}
                                            verticalContainerStyle={scrollbarStyles}
                                            horizontalScrollbarStyle={scrollbarStyles}
                                            horizontalContainerStyle={scrollbarStyles}
                                            smoothScrolling= {true}
                                            minScrollSize={5}
                                            onScroll={this.handleScroll}
                                            >
                                        <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                            <td>#</td>
                                            <td>EMAIL</td>
                                            <td>NAME</td>
                                            <td>등록일</td>
                                            </tr>
                                        </thead>
                                        <tbody>

                                        { this.state.rowlist.map((item, index) =>
                                            <RowItem key={index} item={item} onPress={this.handleRowClick}/>
                                        )}

                                        </tbody>
                                        </Table>
                                        </ScrollArea> */}
                                    </div>
                                </div>
                                <div className="box-footer">
                                    <div className="row">
                                        <div className="col-sm-3 col-xs-6">
                                            <div className="description-block border-right">
                                                {/* <span className="description-percentage text-green"><i className="fa fa-caret-up"></i> 17%</span> */}
                                                {/* <h5 className="description-header">Sending TOTAL: {this.state.sendcount}</h5> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// src/components/Users.js